import React from 'react';
import { Row, Col, Alert, Button, ButtonToolbar } from 'react-bootstrap';
import FieldGroup from './common/FieldGroup.jsx';
import RadioGroup from './common/RadioGroup.jsx';

export default class WashLabelComponent extends React.Component {

  componentDidMount() {
  }

  componentWillUnmount() {
    this.props.cleanAlert();
  }

  render() {

    let downloadLinkStyle = {
      display: this.props.washLabel.get('outputFile') === '' ? 'none' : 'block'
    };

    let openPdf = () => {
      window.open(this.props.washLabel.get('outputFile'));
    };

    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    return (
      <div>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={12} md={12}>
            {alertDiv}
          </Col>
        </Row>
        <Row>
          <Col xs={6} sm={3} md={3}>
            <FieldGroup
              id="serialNoFrom"
              type="number"
              label="序號 From"
              value={this.props.washLabel.get('serialNoFrom')}
              placeholder=""
              onChange={(id, value) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.washLabelValidation.get('serialNoFrom')}
            />
          </Col>
          <Col xs={6} sm={3} md={3}>
            <FieldGroup
              id="serialNoTo"
              type="number"
              label="序號 To"
              value={this.props.washLabel.get('serialNoTo')}
              placeholder=""
              onChange={(id, value) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.washLabelValidation.get('serialNoTo')}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12}>
            <RadioGroup
              id="template"
              label="版型"
              radioList={[{ label: "舊(右)", value: 'template_b' }, { label: "新(右)", value: 'template_new_b' }, { label: "新(橫式)", value: 'template_new_c' }]}
              value={this.props.washLabel.get('template')}
              onChange={(id, value) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.washLabelValidation.get('template')}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6} md={6}>
            <ButtonToolbar>
              <Button bsStyle="info" onClick={this.props.generateWashLabel}>產生PDF檔</Button>
              <Button style={downloadLinkStyle} bsStyle="default" onClick={openPdf}>開啟PDF檔</Button>
            </ButtonToolbar>
          </Col>
        </Row>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/WashLabelComponent.jsx